// This controller updates the current time on calendar and displays a line on the week view timeline.

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["timeline", "earlyHours"]

  connect() {
    this.updateTimeLine()
    this.interval = setInterval(() => this.updateTimeLine(), 60000)
  }

  disconnect() {
    clearInterval(this.interval)
  }

  updateTimeLine() {
    const now = new Date()
    const hours = now.getHours()
    const minutes = now.getMinutes()

    // Calculate the position relative to the 24-hour grid
    const totalMinutes = hours * 60 + minutes
    const gridRowPosition = (totalMinutes / (24 * 60)) * 100 // Percentage position

    // Update the position of the current time line
    this.timelineTarget.style.top = `${gridRowPosition}%`
  }

  expandEarlyHours(event) {
    console.log(event)
    this.earlyHoursTargets.forEach((t) => t.classList.toggle("hidden"))
  }
}
